<template>
  <div
    class="text-sm w-full space-y-2"
   
  >
    <template
      v-for="item in priceBreakdown"
      :key="item.Label?.[localeKey]"
    >
      <TPriceBreakdownItem :item="item">
        <TPriceBreakdownSubItem
          v-for="subitem in item.Items"
          :key="subitem.Label?.[localeKey]"
          :subitem="subitem"
        >
          <template #promo-code-badge="slotProps">
            <slot
              name="promo-code-badge"
              v-bind="slotProps"
            >
              <TPromoCode
                v-if="slotProps.subitem.Type === 'PromoCode'"
                :code="slotProps.subitem.Description?.[localeKey] || ''"
                :is-removable="canRemovePromoCode"
              />
            </slot>
          </template>
        </TPriceBreakdownSubItem>
      </TPriceBreakdownItem>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { BookingPriceBreakdownItem, Nullable } from '~/types'

defineProps<{
  priceBreakdown?: Nullable<BookingPriceBreakdownItem[]>
  canRemovePromoCode?: boolean
}>()

const { localeKey } = useLocaleKey()
</script>
